const appConfig = process.env.REACT_APP_CONFIG || 'nonprod';

export default {
  gtmCode: appConfig === 'nonprod' ? 'GTM-TBTCNL7' : 'GTM-NZG8PH4',
};
